import { Box, Button, Typography, useTheme } from '@mui/material';
import React, { useRef, useState, useEffect } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { tokens } from '../../../global/theme/tokens';
import LabeledBox from '../../special/LabeledBox';
import { useTranslation } from 'react-i18next';

export const TypeDirectFileUpload = ({
  updateValidationOnChange,
  dataCollection,
  errors,
  field,
  size = 'medium',
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const [file, setFile] = useState(null);

  // If form reloads with existing value
  useEffect(() => {
    const existing = dataCollection?.[field.key];
    if (existing) {
      setFile(existing);
    }
  }, [dataCollection, field.key]);

  function handleFileChange(e) {
    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    setFile(selectedFile);
    updateValidationOnChange(field.key, selectedFile);
  }

  function handleRemove() {
    setFile(null);
    updateValidationOnChange(field.key, null);
    if (inputRef.current) {
      inputRef.current.value = null;
    }
  }

  return (
    <Box
      sx={{
        gridColumn: field.colspan
          ? `span ${field.colspan} / span ${field.colspan}`
          : 'auto',
      }}
      className="flex w-full gap-2"
    >
      <LabeledBox
        className="w-full"
        label={field.label}
        onClick={() => !file && inputRef.current?.click()}
      >
        {file ? (
          <Box className="flex items-center gap-2 min-w-0 truncate">
            <Typography className="truncate">{file.name}</Typography>
          </Box>
        ) : (
          <Box className="flex items-center gap-2 opacity-70">
            <UploadFileIcon />
            <Typography>{field.placeholder || t('Add file')}</Typography>
          </Box>
        )}

        <input ref={inputRef} type="file" hidden onChange={handleFileChange} />
      </LabeledBox>

      {/* Delete Button (only if selected) */}
      {file && (
        <Button
          onClick={handleRemove}
          sx={{
            padding: 0,
            width: size === 'small' ? '40px' : '53px',
            bgcolor: colors.bgInput,
            minWidth: '0px',
            border: '1px solid transparent',
            ':hover': {
              bgcolor: colors.error + '30',
              border: `1px solid ${colors.error}80`,
              color: colors.error,
            },
          }}
        >
          <DeleteIcon />
        </Button>
      )}
    </Box>
  );
};
